import { render, staticRenderFns } from "./holdDetail.vue?vue&type=template&id=261fb9ce&scoped=true"
import script from "./holdDetail.vue?vue&type=script&lang=js"
export * from "./holdDetail.vue?vue&type=script&lang=js"
import style0 from "./holdDetail.vue?vue&type=style&index=0&id=261fb9ce&prod&lang=scss&scoped=true"
import style1 from "./holdDetail.vue?vue&type=style&index=1&id=261fb9ce&prod&lang=scss&scoped=true"
import style2 from "./holdDetail.vue?vue&type=style&index=2&id=261fb9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261fb9ce",
  null
  
)

export default component.exports